'use client'

import { Button } from '@/components/ui/button'
import { useRouter } from 'next/navigation'
import Image from 'next/image'

interface Props {
  button?: React.ReactNode
}

const PageError = ({ button }: Props) => {
  const router = useRouter()

  return (
    <div className='h-full flex flex-col items-center justify-center'>
      <div className='text-[0.9rem] absolute top-72 text-center text-[#575757]'>
        <div>예상치 못한 오류로 인해 요청하신 작업을 완료할 수 없습니다</div>
        <div className='mt-1.5'>문제가 계속될 경우 관리자에게 문의해 주세요</div>
      </div>
      <Image src={'/images/error.svg'} alt={'error'} width={500} height={500} priority />
      {button ? (
        button
      ) : (
        <Button
          variant={'link'}
          className='absolute bottom-72 text-center'
          onClick={() => router.push('/')}
        >
          홈으로 이동
        </Button>
      )}
    </div>
  )
}

export default PageError
